import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import EngineeringIcon from '@mui/icons-material/Engineering';
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

const tileIcons = (businessName: string) => {
  switch (businessName) {
    case 'engineers':
      return <EngineeringIcon color='inherit' fontSize='large' />;

    default:
      return <EngineeringIcon color='inherit' fontSize='large' />;
  }
};

const businessFilter = (business: $TSFixMe) => {
  const allowedBusinessNames = ['engineers'];
  if (
    process.env.NODE_ENV !== 'production' ||
    window.location.origin === 'https://staging-calefy.fuseinsurance.ca'
  ) {
    allowedBusinessNames.push('testing_business');
  }
  return allowedBusinessNames.includes(business.internalName);
};

// Engineer Insurance — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'engineersinsurance',
  businessFilter,
  tileIcons,
};
